export default "__VITE_ASSET__avs1jEAT__"